import {personWithKeySvg as Icon__small__personWithKeySvg} from '../Icon__small/Icon__small--personWithKey.js';

export var personWithKey = {
  name: 'personWithKey',
  category: 'icon',
  colorable: true,
  svg: Icon__small__personWithKeySvg,
};
